import React, {useEffect, useRef} from "react";
import Chart from "chart.js/auto";
import 'chartjs-adapter-moment';

import '../../assets/styles/App.css';
import "@fontsource/montserrat";

export default function PlatformDisbursementChart(props) {
    const canvas = useRef(null);

    const screenSize = (window.innerWidth >= 768);

    useEffect(() => {
        const formatNumberWithSpaces = (number) => {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        };

        const config = {
            data: {
                labels: props.labels,
                datasets: [{
                    type: 'bar',
                    label: 'Disbursements',
                    backgroundColor: 'rgba(0, 116, 222, 1)',
                    borderColor: 'rgba(0, 116, 222, 1)',
                    data: props.disbursements,
                    fill: false,
                    // barThickness: 10,
                }
                ],
            },
            options: {
                maintainAspectRatio: false,
                responsive: true,
                plugins: {
                    legend: {
                        display: false,
                        position: 'top',
                        labels: {
                            padding: 30,
                            color: 'white',
                            pointStyle: 'circle',
                            usePointStyle: true,
                        }
                    },
                    tooltip: {
                        mode: "index",
                        intersect: false,
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += formatNumberWithSpaces(Math.round(context.parsed.y));
                                }
                                return label;
                            }
                        }
                    },
                    title: {
                        display: false,
                        text: "Orders Chart",
                    },
                },
                elements: {
                    point: {
                        radius: 0
                    }
                },
                hover: {
                    mode: "nearest",
                    intersect: true,
                },
                scales: {
                    x:
                        {
                            display: true,
                            title: {
                                display: false,
                                labelString: "Funder",
                            },
                            grid: {
                                display: false,
                                color: "rgba(238, 238, 238, 0.1)",
                                zeroLineColor: "rgba(0, 0, 0, 0)",
                            },
                            ticks: {
                                color: 'white',
                            },
                        },
                    y: {
                        type: 'linear',
                        position: 'left',
                        display: true,
                        title: {
                            display: true,
                            fontColor: 'white',
                            labelString: "Disbursement values [USD]",
                        },
                        grid: {
                            display: true,
                            drawBorder: false,
                            color: "rgba(238, 238, 238, 0.1)",
                            zeroLineColor: "rgba(100, 100, 100, 0.1)",
                            zeroLineWidth: 1
                        },
                        ticks: {
                            color: 'white',
                            autoSkip: true,
                            maxTicksLimit: 6,
                            max: 140000000,
                            min: 0,
                            callback: function (value, index, values) {
                                return value / 1e6 + 'M';
                            }
                        },
                    },
                },
            },
        };

        const chart = new Chart(canvas.current, config);

        return () => {
            // need cleanup because React runs useEffect callback twice in dev env
            chart.destroy();
        };

    }, [props.labels, props.disbursements]);
    return (
        <>
            <div className="w-full">
                <p className={`text-yellow text-16-19 mb-6 ${screenSize && 'px-8'}`}>{props.title}</p>
                <div className="relative h-350-px">
                    <canvas ref={canvas}></canvas>
                </div>
            </div>
        </>
    );
}
